// src/utils/logger.js

const runsInBrowser =
  typeof document !== 'undefined' && typeof document.documentElement !== 'undefined';

/** Service worker bundle is production; still route through logger so SW diagnostics appear. */
const runsInServiceWorker =
  typeof importScripts === 'function' && !runsInBrowser;

const isDev = process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'staging';
// if you want to see service worker logs, comment this in:
// const loggingEnabled = isDev || runsInServiceWorker;
const loggingEnabled = isDev;

const noop = () => {};

const logger = {
  log: loggingEnabled ? console.log.bind(console) : noop,
  warn: loggingEnabled ? console.warn.bind(console) : noop,
  error: loggingEnabled ? console.error.bind(console) : noop,
  info: loggingEnabled ? console.info.bind(console) : noop,
  table: loggingEnabled ? console.table.bind(console) : noop,
  group: loggingEnabled ? console.group.bind(console) : noop,
  groupEnd: loggingEnabled ? console.groupEnd.bind(console) : noop,
};

export default logger;
